var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Button from '../../Buttons';
import React, { useRef, useState } from 'react';
var isThenable = function (thing) {
    return !!(thing && !!thing.then);
};
var convertLegacyProps = function (type) {
    if (type === 'danger') {
        return { danger: true };
    }
    return { type: type };
};
var ModalButton = function (_a) {
    var close = _a.close, actionFn = _a.actionFn, buttonProps = _a.buttonProps, type = _a.type, children = _a.children;
    var clickedRef = useRef(false);
    var _b = __read(useState(false), 2), loading = _b[0], setLoading = _b[1];
    var handlePromiseOnOk = function (returnValueOfOnOk) {
        if (!isThenable(returnValueOfOnOk)) {
            return;
        }
        setLoading(true);
        returnValueOfOnOk === null || returnValueOfOnOk === void 0 ? void 0 : returnValueOfOnOk.then(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            close.apply(void 0, __spreadArray([], __read(args), false));
        }).catch(function (e) {
            console.error("confirm modal onOk - " + e);
        }).finally(function () {
            setLoading(false);
            clickedRef.current = false;
        });
    };
    var onClick = function () {
        if (clickedRef.current) {
            return;
        }
        clickedRef.current = true;
        if (!actionFn) {
            close();
            return;
        }
        var returnValueOfOnOk;
        if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        }
        else {
            returnValueOfOnOk = actionFn();
            if (!returnValueOfOnOk) {
                close();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return (React.createElement(Button, __assign({}, convertLegacyProps(type), { onClick: onClick, loading: loading }, buttonProps), children));
};
export default ModalButton;
//# sourceMappingURL=ModalButton.js.map